export default class Tiles {
	pos: number[] = [0,1,2,3,4,5,6,7]

	pos2label(p: number): number {
		for(let i=0; i<this.pos.length; i++) {
			if (this.pos[i] === p) return i+1 // label は index よりも1大きい
		}
		return 0
	}

	moveIfAble(i: number): boolean {
		const p = this.pos[i]
		if (p %3 !== 0 && this.pos2label(p-1) === 0) {
			this.pos[i] -= 1
			return true
		}
		if (p %3 !== 2 && this.pos2label(p+1) === 0) {
			this.pos[i] += 1
			return true
		}
		if (p > 2 && this.pos2label(p-3) === 0) {
			this.pos[i] -= 3
			return true
		}
		if (p < 6 && this.pos2label(p+3) === 0) {
			this.pos[i] += 3
			return true
		}
		return false
	}

	shuffle() {
		let count = 0
		while (count < 300) {
			const target = Math.floor(Math.random()*this.pos.length)
			if (this.moveIfAble(target)) count++
		}
	}

	checkFinish(): boolean {
		for(let i=0; i<this.pos.length; i++) {
			if (this.pos[i] !== i) return false
		}
		return true
	}
}